"use client";

import styled from "styled-components";

interface PageHeaderProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
}

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
`;

const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0;
  line-height: 1.2;
`;

const Description = styled.p`
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0;
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export function PageHeader({ title, description, children }: PageHeaderProps) {
  return (
    <HeaderWrapper>
      <TitleSection>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
      </TitleSection>
      {children && <Actions>{children}</Actions>}
    </HeaderWrapper>
  );
}
